export const createorderQuery = "mutation CreateOrder($input:CreateOrderInput!){createOrder(input:$input){ok}}";
export const loginQuery = "mutation Login($email:String!,$password:String!){token(email:$email,password:$password){accessToken refreshToken expiresIn}}";
export const refreshtokensQuery = "mutation RefreshToken($token:String!){token(refreshToken:$token){accessToken refreshToken expiresIn}}";
export const selfuserQuery = "query SelfUser{user{id name email}}";
